module.exports = __webpack_public_path__ + "media/images/icons/academy-bahasa-ae22dae7f82ae595fcf6446549850b7e.svg";